import React from "react";
import { Loader2 } from "lucide-react";

export function Avatar({ text, brand, size = 24 }) {
  return (
    <div
      style={{ height: size, width: size, fontSize: size * 0.42 }}
      className={`rounded-full shrink-0 flex items-center justify-center font-semibold ${brand ? "bg-[hsl(245,58%,92%)] text-[hsl(245,50%,45%)]" : "bg-[hsl(240,5%,92%)] text-[hsl(240,5%,40%)]"}`}
    >
      {text}
    </div>
  );
}

export function Pill({ className, children }) {
  return <span className={`inline-flex items-center rounded-md px-1.5 py-0.5 text-[12px] font-medium ${className}`}>{children}</span>;
}

export function Chip({ children }) {
  return <span className="inline-flex items-center rounded-md bg-[hsl(240,5%,95%)] px-1.5 py-0.5 text-[12px] text-[hsl(240,6%,20%)]">{children}</span>;
}

export function Spinner({ label = "Loading…" }) {
  return (
    <div className="h-full w-full flex items-center justify-center py-20 text-[hsl(240,4%,55%)]">
      <Loader2 className="h-5 w-5 animate-spin mr-2" /> <span className="text-[13px]">{label}</span>
    </div>
  );
}

export const strengthColor = {
  "Very strong": "bg-emerald-100 text-emerald-700",
  Strong: "bg-green-100 text-green-700",
  Medium: "bg-amber-100 text-amber-700",
  Weak: "bg-[hsl(240,5%,93%)] text-[hsl(240,4%,45%)]",
};

export const companyStatusColor = {
  Customer: "bg-emerald-100 text-emerald-700",
  Prospect: "bg-blue-100 text-blue-700",
  Lead: "bg-amber-100 text-amber-700",
};

export const stageColor = {
  Discovery: "bg-[hsl(240,5%,93%)] text-[hsl(240,4%,45%)]",
  Qualified: "bg-blue-100 text-blue-700",
  Proposal: "bg-violet-100 text-violet-700",
  Negotiation: "bg-amber-100 text-amber-700",
  "Closed Won": "bg-emerald-100 text-emerald-700",
};

export const seqStatusColor = {
  Active: "bg-emerald-100 text-emerald-700",
  Paused: "bg-amber-100 text-amber-700",
  Draft: "bg-[hsl(240,5%,93%)] text-[hsl(240,4%,45%)]",
};

export const stepStatusColor = {
  pending_approval: "bg-amber-100 text-amber-700",
  approved: "bg-blue-100 text-blue-700",
  sending: "bg-violet-100 text-violet-700",
  sent: "bg-emerald-100 text-emerald-700",
  failed: "bg-red-100 text-red-700",
  skipped: "bg-[hsl(240,5%,93%)] text-[hsl(240,4%,45%)]",
};

export const stepStatusLabel = {
  pending_approval: "Pending approval",
  approved: "Approved",
  sending: "Sending",
  sent: "Sent",
  failed: "Send failed",
  skipped: "Skipped",
};

export const MY_TZ = "Asia/Kolkata"; // your timezone (IST)

export function fmtInTz(iso, tz, opts = { weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) {
  if (!iso) return "";
  try { return new Intl.DateTimeFormat("en-US", { timeZone: tz, ...opts }).format(new Date(iso)); }
  catch { return iso; }
}

export function tzAbbr(tz) {
  try {
    const parts = new Intl.DateTimeFormat("en-US", { timeZone: tz, timeZoneName: "short" }).formatToParts(new Date());
    return parts.find((p) => p.type === "timeZoneName")?.value || tz;
  } catch { return tz; }
}
